import BaseResource from './index'
import AgreementResource from '../resources/agreement'
import EntityResource from '../resources/entities'

export default class AgreementEntityResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/agreemententitymx'
    static related() {
        return {
            entity_id: EntityResource,
            agreement_id: AgreementResource,
        }
    }
}
